const PlusSmall = ({ iconColorProp = 'currentColor' }) => (
	<svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false'>
		<path d='M5 1V9M1 5H9' stroke={iconColorProp} strokeWidth='1.6' strokeLinecap='round' />
	</svg>
);

export default PlusSmall;
